import { Route, RouteProps } from "react-router";
import React from "react";
import NewLogin from "../../components/NewLogin/NewLogin";
import { isVodexLoggedin } from "../../components/NewDevelopment/CommonComponents/Common";
import AuthLayout from "../../components/NewDevelopment/auth/AuthLayout";
import NewLoginPage from "../../components/NewDevelopment/auth/Login";

export function AccountRoute({ children, ...rest }: RouteProps) {
  return (
    <Route
      {...rest}
      render={() =>
        isVodexLoggedin() ? (
          <AuthLayout>
            <NewLoginPage />
          </AuthLayout>
        ) : (
          <NewLogin />
        )
      }
    />
  );
}
